<template>
  <div class="wrap-box">
    <div class="log-wrap" v-if="!fromPalmyou">
      <div class="log-body no-required">
        <el-form :model="dataModel" name="loginForm" label-position="top" :rules="rules" ref="dataForm" class="left">
          <div class="login-title">登录</div>

          <el-form-item label="账号" prop="mobile_phone" :required="false">
            <el-input v-model.trim="dataModel.mobile_phone" :maxlength="11" autofocus @keyup.enter.native="formSubmit" placeholder="请填写手机号"></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="passwd" style="margin-bottom:18px">
            <el-input type="password" v-model.trim="dataModel.passwd" :maxlength="20" @keyup.enter.native="formSubmit" placeholder="请输入密码"></el-input>
          </el-form-item>

          <div class="login-addon">
            <router-link :to="{name:'forget'}" class="forget">忘记密码?</router-link>

            <el-checkbox v-model="remember">
              记住登录状态
            </el-checkbox>
          </div>

          <el-button type="primary" @click="formSubmit">登录</el-button>

        </el-form>

        <div class="apply">
          <span>还没有账号?</span>
          <a @click="$service.buriedPoint.goAccountApplication('login')">立即申请</a>
        </div>

        <div class="right">

        </div>
      </div>

      <div class="login-footer">
        Powered by 上上签 © 2016-2019
      </div>

      <el-dialog title="使用协议" v-model="pop" class="pop-wrap" :modal-append-to-body="false">
        <div class="content-wrap">
          <div>
            <div class="title">1、上上签服务条款的接受</div>
            <div class="content">
              通过完成上上签注册程序，用户便表明其接受了本用户协议的条款，并同意受本用户协议的约束；同时，用户保证其提交的信息真实、准确、及时和完整。本用户协议所称的用户是指完全同意所有条款(以下简称“服务条款”)并完成注册程序的服务接受者。
            </div>
          </div>
          <div>
            <div class="title">2、 服务条款的变更和修改</div>
            <div class="content">
              六六六保留依其自主判断在将来的任何时间变更、修改、增加或删除本服务协议条款的权利。所有修改的协议均构成本服务协议的一部分。六六六有权随时对服务条款进行修改，一旦发生服务条款的变动，上上签将提示修改的内容；当用户使用六六六的特殊服务时，应接受六六六随时提供的与该特殊服务相关的规则或说明，并且此规则或说明均构成本服务条款的一部分。用户如果不同意服务条款的修改，可以主动取消已经获得的网络服务；如果用户继续享用网络服务，则视为用户已经接受服务条款的修改。
            </div>
          </div>
          <div>
            <div class="title">3、 服务说明</div>
            <div class="content">
              六六六运用自己的操作系统通过国际互联网向用户提供丰富的网上资源，包括各种信息工具、网上论坛、个性化内容等(以下简称本服务)。除非另有明确规定，增强或强化目前服务的任何新功能，包括新产品，均无条件地适用本服务条款。
    用户理解并同意，六六六的服务是按照现有技术和条件所能达到的现状提供的。六六六会尽最大努力向您提供服务，确保服务的连贯性和安全性；但六六六不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。
              A. 为使用本服务，用户必须：
              (1).自行配备进入国际互联网所必需的设备，包括计算机、数据机，其他存取装置或接受服务所需其它设备；
              (2).自行支付与此服务有关的费用；
              B. 用户接受本服务须同意：
              (1).提供完整、真实、准确、最新的个人资料；
              (2).不断更新注册资料。
              若用户提供任何错误、不实、过时或不完整的资料，或者六六六有合理理由怀疑前述资料为错误、不实、过时或不完整，六六六有权暂停或终止用户的帐号，并拒绝其现在或将来使用本服务的全部或一部分。 六六六有权规定并修改使用本服务的一般措施，包括但不限于决定保留电子邮件讯息或其他上载内容的时间、限制本服务一个帐号可接收信息的数量等措施。如六六六未能储存或删除本服务的内容或其他讯息，六六六不负担任何责任。
              由于用户经由本服务张贴或传送内容、与本服务连线、违反本服务条款或侵害其他人的任何权利导致任何第三方提出权利主张或使六六六遭受任何形式的罚款或处罚，用户同意以适当方式充分消除对上上签的不利影响，赔偿六六六及其分公司、关联公司、代理人或其他合作伙伴及员工的损失，并使其免受损害。
            </div>
          </div>
          <div>
            <div class="title">4、 用户应遵守以下法律及法规 </div>
            <div class="content">
              用户同意遵守中华人民共和国法律法规，尤其是《中华人民共和国保守国家秘密法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》等有关计算机及互联网的法律法规和实施办法。在任何情况下，如果六六六有合理理由认为用户的行为可能违反上述法律、法规，六六六可以在任何时候，不经事先通知终止向该用户提供服务。用户应了解国际互联网的无国界性，应特别注意遵守当地所有有关的法律和法规。
            </div>
          </div>
          <div>
            <div class="title">5、 用户隐私权 </div>
            <div class="content">
              当用户注册六六六的服务时，用户须提供个人信息。六六六收集个人信息的目的是为用户提供尽可能多的个人化网上服务以及为广告商提供一个方便的途径来接触到适合的用户，并且可以发送相关的信息和广告。在此过程中，广告商绝对不会接触到用户的个人信息。
              A. 六六六不会在未经合法用户授权时，公开、编辑或透露其个人信息及保存在上上签中的非公开内容，除非有下列情况：
              (1).有关法律规定或上上签合法服务程序规定；
              (2).在紧急情况下，为维护用户及公众的权益；
              (3).为维护六六六的合法权益；
              (4).其他需要公开、编辑或透露个人信息的情况。
              B. 在以下(包括但不限于)几种情况下，六六六有权使用用户的个人信息：
              (1).在进行促销或抽奖时，六六六可能会与赞助商共享用户的个人信息，在这些情况下六六六会在发送用户信息之前进行提示，并且用户可以通过不参与来终止传送过程。
              (2).六六六可以将用户信息与第三方数据匹配。
              (3).六六六会通过透露合计用户统计数据，向未来的合作伙伴、广告商及其他第三方以及为了其他合法目的而描述六六六的服务。
              六六六会向用户发送用户订制的信息或者六六六认为用户会感兴趣的其他信息。如果用户不希望收到这样的信息，只需在提供个人信息时或其他任何时候告知即可。另外，六六六会采取行业惯用措施保护用户信息的安全，但六六六不能确信或保证任何个人信息的安全性，用户须自己承担风险。比如用户联机公布可被公众访问的个人信息时，用户有可能会收到未经用户同意的信息；六六六的合作伙伴和可通过六六六访问的第三方因特网站点和服务；通过抽奖、促销等活动得知用户个人信息的第三方会进行独立的数据收集工作等活动。六六六对用户及其他任何第三方的上述行为，不承担任何责任。
            </div>
          </div>
          <div>
            <div class="title">6、 用户帐号、密码和安全 </div>
            <div class="content">
              用户一旦注册成功，便成为六六六的合法用户，将得到一个密码和帐号。用户有义务保证密码和帐号的安全。因用户保管不善可能导致遭受盗号或密码失窃，责任由用户自行承担。用户对利用该密码和帐号所进行的一切活动负全部责任；因此所衍生的任何损失或损害，六六六无法也不承担任何责任。
              用户的密码和帐号遭到未授权的使用或发生其他任何安全问题，用户可以立即通知六六六，并且用户在每次连线结束，应结束帐号使用，否则用户可能得不到六六六的安全保护。
            </div>
          </div>
          <div>
            <div class="title">7、 对用户信息的存储和限制 </div>
            <div class="content">
              六六六不对用户所发布信息的删除或储存失败负责。六六六有权判断用户的行为是否符合上上签服务条款规定的权利，如果六六六认为用户违背了服务条款，六六六有权删除用户发布或发送的信息，乃至中断或终止向其提供网络服务。
            </div>
          </div>
          <div>
            <div class="title">8、 禁止用户从事以下行为</div>
            <div class="content">
              (1).上载、张贴、发送或传送任何非法、有害、淫秽、粗俗、猥亵的，胁迫、骚扰、中伤他人的，诽谤、侵害他人隐私或诋毁他人名誉或商誉的，种族歧视或其他不适当的信息或电子邮件，包括但不限于资讯、资料、文字、软件、音乐、照片、图形、信息或其他资料(以下简称内容)。
              (2).以任何方式危害未成年人。
              (3).冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关。
              (4).伪造标题或以其他方式操控识别资料，使人误认为该内容为六六六所传送。
              (5).上载、张贴、发送电子邮件或以其他方式传送无权传送的内容(例如内部资料、机密资料)。
              (6).上载、张贴、发送电子邮件或以其他方式传送侵犯任何人的专利、商标、著作权、商业秘密或其他专属权利之内容。
              (7).在六六六网站专供张贴广告的区域之外，上载、张贴、发送电子邮件或以其他方式传送广告函件、促销资料、"垃圾邮件"等。
              (8).上载、张贴、发送电子邮件或以其他方式传送有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之资料。
              (9).干扰或破坏本服务或与本服务相连的服务器和网络，或不遵守本服务协议之规定。
              (10).故意或非故意违反任何相关的中国法律、法规、规章、条例等其他具有法律效力的规范。
              (11).跟踪或以其他方式骚扰他人。
              (12).其它被六六六视为不适当的行为。
              用户对经由本服务上载、张贴、发送电子邮件或传送的内容负全部责任；对于经由本服务而传送的内容，六六六不保证前述内容的正确性、完整性或品质。用户在接受本服务时，有可能会接触到令人不快、不适当或令人厌恶的内容。在任何情况下，六六六均不对任何内容负责，包括但不限于任何内容发生任何错误或纰漏以及衍生的任何损失或损害。六六六有权(但无义务)自行拒绝或删除经由本服务提供的任何内容。用户使用上述内容，应自行承担风险。
              六六六有权利在下述情况下，对内容进行保存或披露：
              (1) 法律程序所规定；
              (2) 本服务条款规定；
              (3) 被侵害的第三人提出权利主张；
              (4) 为保护六六六、其使用者及社会公众的权利、财产或人身安全。
              (5) 其他六六六认为有必要的情况。
            </div>
          </div>
          <div>
            <div class="title">9. 免责申明</div>
            <div class="content">
              如因不可抗力或其他无法控制的原因造成网站崩溃或无法正常使用，从而导致网上交易无法完成或丢失有关的信息、记录等，六六六将不承担责任。但是我们将会尽合理的可能协助处理善后事宜，并努力使用户减少可能遭受的经济损失。
            </div>
          </div>
          <div>
            <div class="title">10. 适用法律及争议解决</div>
            <div class="content">
              （1）本协议签订地为中华人民共和国广东省深圳市南山区。
              （2）本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
              （3）若您和六六六之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
              （4）本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
              （5）本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
            </div>
          </div>
        </div>
        <el-button type="primary" @click="login">同意使用</el-button>
      </el-dialog>
    </div>

    <div class="loading-box" v-if="fromPalmyou && loadingInstance">
      <svg viewBox="25 25 50 50" class="circular">
        <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
      </svg>
      <p class="text">正在登录...</p>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import sensorsdata from 'sa-sdk-javascript';
import {
  SAVE_MP_WATCH,
  IS_LOGIN,
  QRCODE_GET,
} from '@/store/modules/follow-official-accounts/follow-official-accounts-types';
import {
  SET_PEER_DATA,
} from '@/store/modules/user/user-mutation-types';

import md5 from 'md5';
import User from '../libs/user';
import utils from '../libs/utils';
import Http from '../libs/http';
import { LOGIN_FROM_MAP } from '../maps/sensors-maps';

const { extend } = utils;

export default {
  name: 'Login',
  data() {
    return {
      dataModel: {
        mobile_phone: localStorage.getItem('username') || '',
        passwd: '',
      },
      remember: localStorage.getItem('remember') === '1',
      pop: false,
      rules: {
        mobile_phone: [
          { required: true, trigger: 'blur', message: '请输入账号' },
          { pattern: /^1\d{10}$/, trigger: 'blur', message: '请输入正确的账号' },
        ],
        passwd: [
          { required: true, trigger: 'blur', message: '请输入密码' },
          { min: 6, trigger: 'blur', message: '请输入正确的密码' },
        ],
      },
      userData: {},
      loadingInstance: false,
    };
  },
  computed: {
    passwdEx() {
      return md5(this.dataModel.passwd);
    },
    fromPalmyou() {
      return Boolean(this.$route.query.business_openid);
    },
  },
  methods: {
    ...mapActions('followOA', [
      QRCODE_GET,
    ]),

    ...mapMutations('followOA', [
      SAVE_MP_WATCH,
      IS_LOGIN,
    ]),

    ...mapMutations('user', [
      SET_PEER_DATA,
    ]),

    loginBuriedPoint(peer) {
      let from = this.$route.query.from;

      // 只有直接点了我的订单和消息的时候没有query中的from,所以直接从query中的redirect中取
      if (!from && this.$route.query.redirect) {
        from = this.$route.query.redirect.substring(this.$route.query.redirect.indexOf('/') + 1, this.$route.query.redirect.length);
      }
      sensorsdata.track('login', {
        login_source: LOGIN_FROM_MAP[from],
        peer_name: peer.name,
      });
      sensorsdata.login(peer.visa_peer_id);
    },
    formSubmit() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          const postData = extend({}, this.dataModel, {
            passwd: this.passwdEx,
          });

          // 登录是如果不是金棕榈，则清除掉本地存储中的 is_palmyou（null，0，1）
          if (!this.fromPalmyou) {
            if (localStorage.getItem('is_palmyou')) {
              localStorage.removeItem('is_palmyou');
            }
          }

          // 埋点
          MtaH5.clickStat('submitlogin', { login: 'true' });

          Http.post('/sys/peer_login', postData).then((data) => {
            this.userData = data;
            this.loginBuriedPoint(data);
            if (localStorage.getItem('agree') === '1') {
              this.login();
            } else {
              this.pop = true;
            }
            this.$parent.getStats();
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      });
    },
    login() {
      this.pop = false;
      localStorage.setItem('agree', 1);
      User.login(this.userData);

      Http.post('/peer_account_query', {}, { noToast: true }).then((data) => {
        User.login(extend({}, data, { token: User.token, is_palmyou: User.is_palmyou }), this.remember);
        Http.post('/visa_peer_query').then((peer) => {
          User.peer = peer;
          this.SET_PEER_DATA(peer);
        });
        this.$parent.getStats();

        // 保存用户是否关注公众号的状态
        this.SAVE_MP_WATCH({ mp_watch: User.mp_watch });
        // 保存用户是否关注公众号的状态
        this.IS_LOGIN({ isLogin: 1 });

        if (!User.mp_watch) {
          if (data.wxinfo && data.wxinfo.openid) {
            // 老用户的情况 未关注公众号 但是绑定了微信
            this.QRCODE_GET()
              .then(() => {
                if (this.$route.query.redirect && this.$route.query.redirect.indexOf('bind') < 0) {
                  this.$router.replace(this.$route.query.redirect);
                } else {
                  this.$router.replace('/');
                }
              })
              .catch((e) => {
                if (e) console.log(e);
              });
          } else {
            // 未关注公众号 也没有绑定了微信
            if (this.$route.query.redirect && this.$route.query.redirect.indexOf('bind') < 0) {
              this.$router.replace(this.$route.query.redirect);
            } else {
              this.$router.replace('/');
            }
          }
        } else {
          if ((data.wxinfo && data.wxinfo.openid) || this.fromPalmyou) {
            // 老用户关注公众号 也绑定了微信
            if (this.$route.query.redirect && this.$route.query.redirect.indexOf('bind') < 0) {
              // 如果是金棕榈，且需要跳转到订单详情
              if (this.fromPalmyou && this.$route.query.user_order_id) {
                this.$router.replace({ name: 'orderDetail', params: { oid: +this.$route.query.user_order_id } });
              } else {
                this.$router.replace(this.$route.query.redirect);
              }
            } else {
              this.$router.replace('/');
            }
          } else {
            // 新用户关注公众号 但是没有绑定了微信
            this.QRCODE_GET()
              .then(() => {
                if (this.$route.query.redirect && this.$route.query.redirect.indexOf('bind') < 0) {
                  this.$router.replace(this.$route.query.redirect);
                } else {
                  this.$router.replace('/');
                }
              })
              .catch((e) => {
                if (e) console.log(e);
              });
          }
        }
      }, (e) => {
        if (e) console.log(e);
        User.logout(true);
      });

      if (this.remember) {
        localStorage.setItem('username', this.dataModel.mobile_phone);
        localStorage.setItem('remember', 1);
      } else {
        localStorage.removeItem('username');
        localStorage.setItem('remember', 0);
      }
    },
    // 获取金棕榈用户信息,然后自动登录
    getPalmyouInfo() {
      this.loadingInstance = true;

      Http.post('/sys/palmyou_login', { business_openid: this.$route.query.business_openid }).then((data) => {
        this.userData = data;
        this.login();
      }).catch((e) => {
        if (e) console.log(e);
        this.loadingInstance = false;
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (!to.query.redirect && from.fullPath.indexOf('forget') < 0 && from.fullPath.indexOf('join') < 0) {
      return next({ path: '/login', query: { redirect: from.fullPath, from: to.query.from } });
    }

    next();
  },
  created() {
    if (this.fromPalmyou) {
      this.getPalmyouInfo();
    }
  },
};
</script>

<style lang="less">
.log-wrap{
	position:fixed;
	z-index:1;
	top:60px;
	left:0;
	right:0;
	bottom:0;
	min-height:600px;
	background:url(../assets/imgs/login.png) no-repeat center bottom;
	padding-top: 95px;

	.login-title{
		color:#777;
		font-size:20px;
		padding-right:83px;
		text-align:center;
		margin-bottom:40px;
	}

	.login-addon{
		padding-right:83px;
	}

	.forget{
		float:right;
		font-size:14px;
		color:#5e9be1;
	}

	.log-body{
		box-shadow:0 1px 7px -3px #555;
		width: 800px;
		height: 410px;
		margin:0 auto;
		background-color: #fff;
		position: relative;
		border-radius:4px;

		&>*{
			position: absolute;
		}
		.left{
			width: 466px;
			left:0;
			top:38px;
			padding-left: 83px;
			font-size: 14px;
			color:#777;
			p{
				height:30px;
				line-height: 30px;
			}
		}

		.right{
			background:url(../assets/imgs/slogan.png) no-repeat center center;
			background-size:180px 210px;
			top:0;
			bottom:0;
			right:0;
			width:334px;
			border-left:1px dashed #ececec;
		}

		.el-input__inner{
			width: 300px;
			height:40px;
		}
		.el-button{
			margin-top: 20px;
			display: block;
			width: 300px;
			height:40px;
			font-size:16px;
		}
	}
	.pop-wrap{
		.el-dialog{
			top:20%!important;
		}
		.el-button{
			width: 240px;
			height:40px;
			font-size: 16px;
			margin:15px auto 0 auto;
			display:block;
		}
		.content-wrap{
			margin:auto;
			height:320px;
			overflow-y: auto;
			padding:0 42px;
			.content{
				text-indent: 20px;
				font-size: 12px;
				margin-top: 8px;
				line-height: 19px;
				font-size: 12px;
				margin-bottom: 19px
			}
		}
	}

	.login-footer{
		text-align:center;
		font-size:12px;
		color:#aaa;
		margin-top:22px;
	}

  .apply{
    position: absolute;
    bottom: 30px;
    left: 152px;
    color: #5e9be1;
    font-size: 14px;
    a{
      color: #5e9be1;
    }
  }
}
.loading-box{
  position: fixed;
  z-index: 1000;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  min-height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: hsla(0,0%,100%,.9);
  .circular{
    width: 42px;
    height: 42px;
    animation: loading-rotate 2s linear infinite;
  }
  .path{
    animation: loading-dash 1.5s ease-in-out infinite;
    stroke-dasharray: 90,150;
    stroke-dashoffset: 0;
    stroke-width: 2;
    stroke: #5e9be1;
    stroke-linecap: round;
  }
  .text{
    color: #5e9be1;
    margin: 10px 0;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue